import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Invoice_header from '../Header/Invoice_header';
import "../../styles/InvoiceEdit.css";
import back_arrow from "../../assets/svg/back-arrow.svg";
import upload_icon from "../../assets/svg/upload_icon.svg";
import excel_icon from "../../assets/svg/excel_icon.svg";
import small_line from "../../assets/svg/small_line.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import axios from 'axios';
import "../../styles/invoice_addnew.css";
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from '../../axiosInstance';
import tick_icon from "../../assets/svg/tick_icon.svg"
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";



const InvoiceEditModule = () => {

    // let ModuleId = 10
    let ModuleId = 24
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const invoice = state?.invoice || {};
    const [allCategories, setAllCategories] = useState([]);
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [sapDetails, setSapDetails] = useState({});
    const [jobTypes, setJobTypes] = useState([]);
    const [summary, setSummary] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDraft, setIsDraft] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [projectId, setselectedprojectId] = useState(0);
    const [selectedChargeIds, setSelectedChargeIds] = useState({});
    const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
    const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
    const [inputValues, setInputValues] = useState({});
    const [activeTab, setActiveTab] = useState('jobs'); // Default to 'jobs' ta
    const [showTimeline, setShowTimeline] = useState(true);
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [actionType, setActionType] = useState(""); // 'approved' or 'rejected'
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState('');


    const openModal = (type) => {
        setActionType(type);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setComment("");
    };


    useEffect(() => {
        const fetchInvoiceData = async () => {
            if (invoice.id) {
                setIsLoading(true);
                try {
                    // const response = await axios.get(
                    //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/edit/${invoice.id}`
                    // );

                    const response = await axiosInstance.get(
                        `/invoice/edit/${invoice.id}`
                    );

                    console.log("Invoice Responseee Edit Data", response.data);

                    if (response.data && response.data.success) {
                        const data = response.data.data;

                        console.log("Fetched invoice_details", data.invoice_details);
                        console.log("Fetched summary", data.summary);
                        console.log("Fetched line_items", data.line_items);
                        console.log("Fetched sap_details", data.sap_details);

                        setInvoiceDetails(data.invoice_details[0] || {});
                        setSapDetails(data.sap_details[0] || {});
                        setJobTypes(data.job_types || []);
                        setSummary(data.summary || []);
                        setselectedprojectId(data.invoice_details[0]?.project_id);
                        // Inside fetchInvoiceData, after setting other states:
                        setApprovalHistory(data.approval_history || []);

                        // Transform line items into categories format
                        const transformedCategories = data.line_items.map(item => {
                            const jobIdFromDetails = item.details.find(detail => detail.job_id)?.job_id || '';
                            const jobTypeFromDetails = item.details.find(detail => detail.job_type)?.job_type || '';
                            const quantityFromDetails = item.details.find(detail => detail.unit_of_quantity)?.unit_of_quantity || '0';
                            const rateFromDetails = item.details.find(detail => detail.unit_of_rate)?.unit_of_rate || '0';
                            const netValueFromDetails = item.details.find(detail => detail.net_total)?.net_total || '0';
                            const jobtypeidFromDetails = item.details.find(detail => detail.job_type_id)?.job_type_id || '0';

                            return {
                                jobnumber: item.job_no,
                                accrual: item.accrual,
                                id: jobIdFromDetails,
                                jobTypeId: jobtypeidFromDetails,
                                jobType: jobTypeFromDetails,
                                quantity: quantityFromDetails,
                                rate: rateFromDetails,
                                netValue: netValueFromDetails,
                                rows: item.details.map(detail => ({
                                    // billingtype: detail.job_type || "",
                                    chargecode: detail.charge_code || "",
                                    // elements: detail.charge_name || "",
                                    description: detail.description || "",
                                    unitQuantity: detail.unit_of_quantity || "",
                                    unitRatePrice: detail.unit_of_rate || "",
                                    netTotal: detail.net_total || "",
                                    accrualSplit: detail.accrual || "",
                                    jobTypeId: detail.job_type_id || 0,
                                    chargeId: detail.charge_id || 0,
                                    // attachment: "",
                                    // attachmentUrl: detail.attachment_url || null,
                                    attachment: detail.attachment_url || "",
                                    existingAttachmentUrl: detail.attachment_url || "",
                                    uploadedFiles: [],
                                    isChecked: false
                                }))
                            };
                        });

                        setAllCategories(transformedCategories);

                        // Initialize inputValues with the charge codes from the data
                        const initialInputValues = {};
                        transformedCategories.forEach((category, catIndex) => {
                            initialInputValues[catIndex] = {};
                            category.rows.forEach((row, rowIndex) => {
                                initialInputValues[catIndex][rowIndex] = row.chargecode || "";
                            });
                        });
                        setInputValues(initialInputValues);

                        // Initialize selectedChargeIds with the charge ids from the data
                        const initialSelectedChargeIds = {};
                        transformedCategories.forEach((category, catIndex) => {
                            category.rows.forEach((row, rowIndex) => {
                                initialSelectedChargeIds[`${catIndex}_${rowIndex}`] = row.chargeId || 0;
                            });
                        });
                        setSelectedChargeIds(initialSelectedChargeIds);


                        // Set status flags
                        const status = data.invoice_details[0]?.approval_status?.toLowerCase();
                        setIsDraft(status === 'draft' || status === 'rejected');
                        setIsSubmitted(status === 'submitted' || status === 'approved' || status === 'completed' || status === 'rejected' || status === 're-submitted' || status === 'sap pushed' || status === 'final invoice');
                    }
                } catch (error) {
                    console.error("Error fetching invoice data:", error);
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchInvoiceData();
    }, [invoice]);


    const addRow = (categoryId) => {
        if (!isDraft) return; // Only allow adding rows for draft invoices

        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: [
                            ...category.rows,
                            {
                                billingtype: "",
                                chargecode: "",
                                elements: "",
                                description: "",
                                unitQuantity: "",
                                unitRatePrice: "",
                                netTotal: "",
                                accrualSplit: "",
                                attachment: "",
                                uploadedFiles: [],
                                isChecked: false
                            },
                        ],
                    }
                    : category
            )
        );
    };

    const handleFileUpload = (e, categoryId, index, lineindex) => {
        const files = Array.from(e.target.files);

        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex ? { ...row, uploadedFiles: [...(row.uploadedFiles || []), ...files] } : row
                        ),
                    }
                    : category
            )
        );
    };

    const handleRemoveFile = (categoryId, index, lineindex, fileIndex) => {
        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex
                                ? {
                                    ...row,
                                    uploadedFiles: row.uploadedFiles.filter((_, index) => index !== fileIndex),
                                }
                                : row
                        ),
                    }
                    : category
            )
        );
    };

    const handleRemoveAttachment = (categoryId, index, lineindex) => {
        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex
                                ? {
                                    ...row,
                                    attachment: "",
                                    existingAttachmentUrl: "",
                                    uploadedFiles: []
                                }
                                : row
                        ),
                    }
                    : category
            )
        );
    };



    const handleInputChange = (e, categoryId, rowIndex, field) => {
        if (!isDraft) return; // Only allow input changes for draft invoices

        const { value } = e.target;

        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) => {
                            if (i === rowIndex) {
                                const updatedRow = { ...row, [field]: value };

                                if (field === 'unitQuantity' || field === 'unitRatePrice') {
                                    const quantity = parseFloat(updatedRow.unitQuantity) || 0;
                                    const rate = parseFloat(updatedRow.unitRatePrice) || 0;
                                    updatedRow.netTotal = (quantity * rate).toString();
                                }

                                return updatedRow;
                            }
                            return row;
                        }),
                    }
                    : category
            )
        );
    };

    const deleteRow = (categoryId, rowIndex) => {
        if (!isDraft) return; // Only allow row deletion for draft invoices

        setAllCategories(prevCategories =>
            prevCategories.map(category => {
                if (category.id === categoryId) {
                    const newRows = [...category.rows];
                    newRows.splice(rowIndex, 1);
                    return { ...category, rows: newRows };
                }
                return category;
            })
        );
    };

    const handleUpdate = async (actionType) => {
        if (!isDraft) return; // Only allow submission for draft invoices

        for (let category of allCategories) {
            for (let row of category.rows) {
                const { chargecode, description, unitQuantity, unitRatePrice, netTotal } = row;

                if (!chargecode || !chargecode.trim()) {
                    toast.error("Charge Code is required");
                    return;
                }

                if (!description || !description.trim()) {
                    toast.error("Description of Charges is required");
                    return;
                }

                if (!unitQuantity || isNaN(unitQuantity)) {
                    toast.error("Unit Quantity is required");
                    return;
                }

                if (!unitRatePrice || isNaN(unitRatePrice)) {
                    toast.error("Unit Rate Price is required");
                    return;
                }

                if (!netTotal || isNaN(netTotal)) {
                    toast.error("Net Total is required");
                    return;
                }

            }
        }

        try {
            const jobs = allCategories.map((category, categoryIndex) => ({
                id: category.id,
                jobnumber: category.jobnumber,
                project_id: parseInt(projectId) || 0,
                job_type_id: category.rows[0]?.jobTypeId || 0,
                job_created_date: new Date().toISOString().split("T")[0],
                job_line: category.rows.map((row, rowIndex) => {
                    const attachmentKey = `${categoryIndex}_${rowIndex}`;
                    const hasNewFile = row.uploadedFiles?.length > 0;

                    return {
                        project_id: parseInt(projectId) || 0,
                        job_type_id: row.jobTypeId || 0,
                        charge_id: Array.isArray(selectedChargeIds[`${categoryIndex}_${rowIndex}`])
                            ? selectedChargeIds[`${categoryIndex}_${rowIndex}`]
                            : [selectedChargeIds[`${categoryIndex}_${rowIndex}`] || row.chargeId || 0],
                        description_of_charges: row.description || "",
                        unit_of_quantity: parseFloat(row.unitQuantity) || 0,
                        unit_of_rate: parseFloat(row.unitRatePrice) || 0,
                        net_total: parseFloat(row.netTotal) || 0,
                        accrual: parseFloat(row.accrualSplit) || 0,
                        attachment_key: attachmentKey,
                        ...(hasNewFile
                            ? {}
                            : row.existingAttachmentUrl && { existing_attachment_url: row.existingAttachmentUrl }),
                    };
                })
            }));

            const payload = {
                jobs,
                actions: [actionType],
                update_invoice: "1",
                invoice_id: invoice.id,
                approval_status: invoice.approval_status
            };

            const formData = new FormData();
            formData.append("data", JSON.stringify(payload));

            allCategories.forEach((category, categoryIndex) => {
                category.rows.forEach((row, rowIndex) => {
                    if (row.uploadedFiles?.length > 0) {
                        row.uploadedFiles.forEach(file => {
                            const attachmentKey = `${categoryIndex}_${rowIndex}`;
                            formData.append(`attachments[${attachmentKey}][]`, file);
                        });
                    }
                });
            });

            // const response = await axios.post(
            //     'https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/save',
            //     formData,
            //     { headers: { 'Content-Type': 'multipart/form-data' } }
            // );

            const response = await axiosInstance.post(
                '/invoice/save',
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.data.success) {
                toast.success('Invoice updated successfully!');
                navigate(-1); // Go back to previous page
            } else {
                toast.error('Failed to update invoice: ' + (response.data.message || 'Unknown error'));
            }
        } catch (error) {
            console.error('Error updating invoice:', error);
            toast.error('An error occurred while updating the invoice');
        }
    };

    const handleApprove = async () => {
        try {
            // const response = await axios.post(
            //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/approve/${invoice.id}`
            // );

            const response = await axiosInstance.post(
                `/invoice/approve/${invoice.id}`
            );

            if (response.data.success) {
                alert('Invoice approved successfully!');
                navigate(-1);
            } else {
                alert('Failed to approve invoice: ' + (response.data.message || 'Unknown error'));
            }
        } catch (error) {
            console.error('Error approving invoice:', error);
            alert('An error occurred while approving the invoice');
        }
    };

    const handleReject = async () => {
        try {
            // const response = await axios.post(
            //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/reject/${invoice.id}`
            // );

            const response = await axiosInstance.post(
                `/invoice/reject/${invoice.id}`
            );

            if (response.data.success) {
                alert('Invoice rejected successfully!');
                navigate(-1);
            } else {
                alert('Failed to reject invoice: ' + (response.data.message || 'Unknown error'));
            }
        } catch (error) {
            console.error('Error rejecting invoice:', error);
            alert('An error occurred while rejecting the invoice');
        }
    };



    const handleInvoiceAction = async () => {
        if (!comment.trim()) {
            setCommentError("Comment is required.");
            return;
        }

        setCommentError(''); // clear error if valid

        const payload = {
            invoice_id: invoice.id,
            project_id: invoiceDetails.project_id,
            module: "3",
            comments: comment,
            status: actionType
        };

        try {
            const response = await axiosInstance.post(`/approve_reject_btns`, payload);

            console.log("approve_reject response", response);

            if (response.status === 200) {
                alert(`Invoice ${actionType} successfully!`);
                navigate(-1);
            } else {
                alert(`Failed to ${actionType} invoice: ${response.data.message || 'Unknown error'}`);
            }

        } catch (error) {
            console.error(`Error ${actionType} invoice:`, error);
            alert(`An error occurred while ${actionType} the invoice`);
        } finally {
            closeModal();
        }
    };








    const calculateCategoryTotals = (category) => {
        const totals = {
            quantity: 0,
            rate: 0,
            netValue: 0
        };

        category.rows.forEach(row => {
            totals.quantity += parseFloat(row.unitQuantity) || 0;
            totals.rate += parseFloat(row.unitRatePrice) || 0;
            totals.netValue += parseFloat(row.netTotal) || 0;
        });

        return totals;
    };

    const fetchSuggestions = async (searchTerm = "", rowIndex, index, projectId) => {
        try {
            setSuggestionsMap([]);

            // const response = await axios.get(
            //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${projectId}`,
            //     {
            //         params: {
            //             term: searchTerm
            //         }
            //     }
            // );

            const response = await axiosInstance.get(
                `/project_based/getchargecodes/${projectId}`,
                {
                    params: {
                        term: searchTerm
                    }
                }
            );

            if (response.data?.chargecodes) {

                const newSuggestions = response.data?.chargecodes || [];
                setSuggestionsMap(prev => {
                    const updated = { ...prev };
                    if (!updated[index]) updated[index] = {}; // initialize if empty
                    updated[index][rowIndex] = newSuggestions;
                    console.log("Updated suggestionsMap:", updated);
                    return updated;
                });

                setShowSuggestionsMap(prev => ({
                    ...prev,
                    [`${index}_${rowIndex}`]: true,
                }));
            }
        } catch (err) {
            console.error("Failed to fetch suggestions", err);

            setSuggestionsMap(prev => {
                const updated = { ...prev };
                if (!updated[index]) updated[index] = {};
                updated[index][rowIndex] = []; // clear only that one
                return updated;
            });

            setShowSuggestionsMap(prev => ({
                ...prev,
                [`${index}_${rowIndex}`]: false,
            }));
        }
    };

    const handleDownload = async (attachmentUrl) => {
        try {
            // Check if the URL is valid
            if (!attachmentUrl) {
                toast.error("No attachment available");
                return;
            }

            // Create a temporary anchor element
            const link = document.createElement('a');
            link.href = attachmentUrl;

            // Extract filename from URL or use a default name
            const fileName = attachmentUrl.split('/').pop() || 'document';
            link.setAttribute('download', fileName);

            // Append to DOM, trigger click, then remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
            toast.error('Failed to download file');
        }
    };

    const historyData = [
        { status: 'Approved', name: 'Purushothaman', id: 'M200', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },

    ];

    if (!showTimeline) return null;

    return (
        <>
            <Invoice_header />
            <div className='invoice_module'>
                <div className="invoice-module-header">
                    <div className="invoice-module-header-left">
                        <img
                            src={back_arrow}
                            alt="Back Arrow"
                            onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }}
                        />
                        <p className="new_job">{invoice.inv_number}</p>
                    </div>
                    <div className="invoice-module_header_right">
                        {isDraft && (
                            <>
                                <button className="edit_btn" onClick={() => navigate(-1)} >
                                    Cancel
                                </button>
                                <button className="edit_btn" onClick={() => handleUpdate("save")} >
                                    save
                                </button>
                                <button className="edit_btn" onClick={() => handleUpdate("submit")}>
                                    submit
                                </button>
                            </>
                        )}
                        {isSubmitted && invoiceDetails.approve_reject_btn === true && (
                            <>
                                <button className="reject_btn" onClick={() => openModal('rejected')}>
                                    Reject
                                </button>
                                <button className="approve_btn" onClick={() => openModal('approved')}>
                                    Approve
                                </button>
                            </>
                        )}

                        {isModalOpen && (
                            <div className="modal" onClick={closeModal}>
                                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                    <h3>{actionType === 'approved' ? 'Approve' : 'Reject'} Invoice</h3>
                                    <textarea
                                        value={comment}
                                        onChange={(e) => {
                                            setComment(e.target.value);
                                            if (e.target.value.trim()) setCommentError('');
                                        }}
                                        placeholder="Enter your comments"
                                    />
                                    {commentError && <div className="error-msg">{commentError}</div>}

                                    <div className="modal-buttons">
                                        <button onClick={closeModal}>Cancel</button>
                                        <button onClick={handleInvoiceAction}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>

                <div className='invoice-module-details'>
                    <div className='invoice-module-job-details'>
                        <p className='invoice-module-invoice-details-header'>Invoice details</p>
                        <div className='invoice-module-main-details-grid' style={{ display: 'flex', gap: '20px', alignItems: 'stretch' }}>
                            <div className='invoice-module-details-grid'>
                                <p className='invoice-module-invoice-details-label'>Invoice No</p>
                                <p className='invoice-module-invoice-details-value'>{invoiceDetails.inv_number}</p>

                                <p className='invoice-module-invoice-details-label'>Project</p>
                                <p className='invoice-module-invoice-details-value'>{invoice.project}</p>

                                <p className='invoice-module-invoice-details-label'>Period</p>
                                <p className='invoice-module-invoice-details-value'>Monthly</p>

                                <p className='invoice-module-invoice-details-label'>Created Date</p>
                                <p className='invoice-module-invoice-details-value'>{invoiceDetails.created_date}</p>

                                <p className='invoice-module-invoice-details-label'>Status</p>
                                <p className='invoice-module-invoice-details-value'>
                                    <span className={`status-badge ${invoice.approval_status}`}>
                                        {invoice.approval_status}
                                    </span>
                                </p>
                            </div>

                            {invoice.approval_status?.toLowerCase() === 'final invoice' && (
                                <>
                                    <div style={{ borderLeft: '1px solid #ddd', margin: '0 20px' }}></div>

                                    <div className='invoice-module-details-grid' >
                                        <p className='invoice-module-invoice-details-label'>SAP Doc Number</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.sap_doc_no ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>ODN Number</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.odn_number ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Bill Gross Amount</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.bill_gross_amount ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>SAP Invoice Date</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.sap_invoice_date ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                    </div>
                                </>
                            )}
                        </div>



                        <div className='invoice-module-job-types'>
                            <div className='job-types-content'>
                                <p className='invoice-module-invoice-details-header'>Job types - {jobTypes.length}</p>
                                <div className='job-types-buttons'>
                                    {jobTypes.map((jobType, index) => (
                                        <button key={index} className='invoice-module-invoice-details-data'>
                                            {jobType.job_type_name}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="invoice_module_project">
                            <div className="invoice-module-project-summary">
                                <p className="invoice-module-summary-summary">Summary</p>
                                <table className="invoice-module-summary-table">
                                    <thead>
                                        <tr>
                                            <th>Jobs</th>
                                            <th>Quantity</th>
                                            <th>Rate</th>
                                            <th>Net Value</th>
                                        </tr>
                                    </thead>
                                    {summary.map((item, index) => (
                                        <tr key={index}>
                                            <td>Job No: {item.job_no}</td>
                                            <td>{item.quantity}</td>
                                            <td>{item.rate}</td>
                                            <td>{item.net_value}</td>
                                        </tr>
                                    ))}
                                    <tr className="total-row">
                                        <td>Total</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0)}</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.rate || 0), 0)}</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.net_value || 0), 0)}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="invoice_popup_categories">
                    {isSubmitted && (
                        <div className="invoice-module-button">
                            <button
                                className={`edit_btn ${activeTab === 'jobs' ? 'active-tab' : ''}`}
                                onClick={() => setActiveTab('jobs')}
                            >
                                Jobs
                            </button>
                            <button
                                className={`edit_btn ${activeTab === 'approval' ? 'active-tab' : ''}`}
                                onClick={() => setActiveTab('approval')}
                            >
                                Approval Flow
                            </button>
                        </div>
                    )}
                    {/* {isDraft && (
                        <p className="invoice-module-summary-summary">Jobs</p>
                    )} */}
                    {(activeTab === 'jobs') && (
                        <div>
                            {allCategories.map((category, index) => {
                                const totals = calculateCategoryTotals(category);
                                return (
                                    <div key={category.id} style={{ marginTop: '30px' }} className="invoice_popup_outercategory">
                                        <div className="invoice_popup_category_header">
                                            <div className="category_name_left">
                                                <span className="category_name">Job No: {category.jobnumber}</span>
                                            </div>
                                            <div className="category_name_left">
                                                <span className="category_name_netvalue">
                                                    Accrual : <span className="number_highlight">{Number(category.accrual).toFixed(2)}</span>
                                                </span>
                                            </div>
                                            <div className="category_name_right">
                                                <span className="category_name_quantity">
                                                    Quantity : <span className="number_highlight">{totals.quantity.toFixed(2)}</span>
                                                </span>
                                                <img src={small_line} alt="" />
                                                <span className="category_name_rate">
                                                    Rate : <span className="number_highlight">{totals.rate.toFixed(2)}</span>
                                                </span>
                                                <img src={small_line} alt="" />
                                                <span className="category_name_netvalue">
                                                    Net Value :
                                                    <span className="number_highlight">{totals.netValue.toFixed(2)}</span>
                                                    &nbsp;
                                                    {(() => {
                                                        const accrual = parseFloat(category.accrual) || 0;
                                                        const diff = totals.netValue - accrual;
                                                        const isPositive = diff >= 0;
                                                        return (
                                                            <span className={isPositive ? "diff_positive" : "diff_negative"}>
                                                                ({isPositive ? '+' : ''}{diff.toFixed(2)})
                                                            </span>
                                                        );
                                                    })()}
                                                </span>

                                            </div>
                                        </div>

                                        <div className="invoice_popup_category_subheader">
                                            <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                                <div className="table-container">
                                                    <table className="invoice_table">
                                                        <thead>
                                                            <tr>
                                                                {/* <th>
                                                        <input
                                                            type="checkbox"
                                                            style={{
                                                                width: "14px",
                                                                height: "14px",
                                                                borderRadius: "2px",
                                                            }}
                                                            disabled={!isDraft}
                                                        />
                                                    </th> */}
                                                                <th>CHARGE CODE</th>
                                                                <th>DESCRIPTION OF CHARGES</th>
                                                                <th>ACCRUAL SPLIT</th>
                                                                <th>UNIT OF QUANTITY</th>
                                                                <th>UNIT RATE PRICE</th>
                                                                <th>NET TOTAL</th>
                                                                <th>ATTACHMENT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {category.rows.map((row, lineindex) => (
                                                                <tr key={lineindex}>
                                                                    {/* <td>
                                                            <input 
                                                                type="checkbox" 
                                                                disabled={!isDraft}
                                                            />
                                                        </td> */}
                                                                    <td style={{ position: "relative" }}>
                                                                        {isSubmitted ? (
                                                                            <input
                                                                                type="text"
                                                                                value={row.chargecode}
                                                                                onChange={(e) => handleInputChange(e, category.id, lineindex, "chargecode")}
                                                                                className="invoice_small_input"
                                                                                disabled={!isDraft}
                                                                            />
                                                                        ) : (
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    value={inputValues[index]?.[lineindex] || ""}
                                                                                    onChange={(e) => {
                                                                                        const val = e.target.value;
                                                                                        handleInputChange(e, index, lineindex, "chargecode");
                                                                                        setInputValues((prev) => ({
                                                                                            ...prev,
                                                                                            [index]: {
                                                                                                ...prev[index],
                                                                                                [lineindex]: val,
                                                                                            },
                                                                                        }));
                                                                                        fetchSuggestions(val, lineindex, index, projectId);
                                                                                    }}
                                                                                    onFocus={() => {
                                                                                        const list = suggestionsMap[index]?.[lineindex] || [];
                                                                                        if (list.length > 0) {
                                                                                            setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                                                                        }
                                                                                    }}
                                                                                    onBlur={() => {
                                                                                        setTimeout(() => {
                                                                                            setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                                                                        }, 200);
                                                                                    }}
                                                                                    className="invoice_small_input"
                                                                                    placeholder="Search"
                                                                                />

                                                                                {showSuggestionsMap[`${index}_${lineindex}`] && suggestionsMap[index]?.[lineindex]?.length > 0 && (
                                                                                    <ul
                                                                                        style={{
                                                                                            position: "absolute",
                                                                                            top: "100%",
                                                                                            left: 0,
                                                                                            right: 0,
                                                                                            backgroundColor: "white",
                                                                                            border: "1px solid #ccc",
                                                                                            zIndex: 999,
                                                                                            maxHeight: "150px",
                                                                                            overflowY: "auto",
                                                                                            margin: 0,
                                                                                            padding: 0,
                                                                                            listStyle: "none",
                                                                                        }}
                                                                                    >
                                                                                        {suggestionsMap[index]?.[lineindex].map((item) => (
                                                                                            <li
                                                                                                key={item.value}
                                                                                                onMouseDown={() => {
                                                                                                    const selected = item.label;
                                                                                                    const chargeId = item.value;

                                                                                                    setInputValues((prev) => ({
                                                                                                        ...prev,
                                                                                                        [index]: {
                                                                                                            ...prev[index],
                                                                                                            [lineindex]: selected,
                                                                                                        },
                                                                                                    }));

                                                                                                    setSelectedChargeIds((prev) => ({
                                                                                                        ...prev,
                                                                                                        [`${index}_${lineindex}`]: chargeId
                                                                                                    }));

                                                                                                    handleInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                                                                    setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                                                                                }}
                                                                                                style={{
                                                                                                    padding: "8px",
                                                                                                    cursor: "pointer",
                                                                                                    borderBottom: "1px solid #eee",
                                                                                                }}
                                                                                            >
                                                                                                {item.label}
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            value={row.description}
                                                                            onChange={(e) => handleInputChange(e, category.id, lineindex, "description")}
                                                                            className="invoice_small_input"
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.accrualSplit}
                                                                            readOnly
                                                                            className="invoice_small_input"
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.unitQuantity}
                                                                            onChange={(e) => handleInputChange(e, category.id, lineindex, "unitQuantity")}
                                                                            className="invoice_small_input"
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.unitRatePrice}
                                                                            onChange={(e) => handleInputChange(e, category.id, lineindex, "unitRatePrice")}
                                                                            className="invoice_small_input"
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.netTotal}
                                                                            readOnly
                                                                            className="invoice_small_input"
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <div className="file_upload_wrapper">
                                                                            {/* Uploaded files */}
                                                                            {row.uploadedFiles && row.uploadedFiles.length > 0 && (
                                                                                <div className="uploaded_files">
                                                                                    {row.uploadedFiles.map((file, fileIndex) => (
                                                                                        <div key={fileIndex} className="uploaded_file_item">
                                                                                            <img
                                                                                                src={file.name.match(/\.(xls|xlsx)$/i) ? excel_icon : upload_icon}
                                                                                                alt="File"
                                                                                                className="file_icon"
                                                                                            />
                                                                                            <span className="file_name">{file.name}</span>
                                                                                            {isDraft && (
                                                                                                <button
                                                                                                    className="remove_file_btn"
                                                                                                    onClick={() => handleRemoveFile(category.id, index, lineindex, fileIndex)}
                                                                                                >
                                                                                                    ⨉
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}

                                                                            {/* Existing attachment from API */}
                                                                            {!row.uploadedFiles?.length && row.attachment && (
                                                                                <div className="attachment_view_section">
                                                                                    <a
                                                                                        href={row.attachment}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="view_link"
                                                                                    >
                                                                                        <i className="fa fa-eye" style={{ marginRight: "5px" }}></i>
                                                                                        <span className="view_text">View</span>
                                                                                    </a>
                                                                                    {isDraft && (
                                                                                        <button
                                                                                            className="remove_file_btn"
                                                                                            onClick={() => {
                                                                                                const updatedCategories = [...allCategories];
                                                                                                updatedCategories[index].rows[lineindex].attachment = null;
                                                                                                setAllCategories(updatedCategories);
                                                                                            }}
                                                                                        >
                                                                                            ⨉
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            )}

                                                                            {/* Upload option */}
                                                                            {isDraft && !row.uploadedFiles?.length && !row.attachment && (
                                                                                <label className="file_upload">
                                                                                    <input
                                                                                        type="file"
                                                                                        multiple
                                                                                        onChange={(e) => handleFileUpload(e, category.id, index, lineindex)}
                                                                                        style={{ display: "none" }}
                                                                                    />
                                                                                    <img src={upload_icon} alt="Upload" className="upload_icon" />
                                                                                    <span className="upload_text">Upload</span>
                                                                                </label>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                    <AdditionalPermissionWrapper permissionKey="edit_inv_line" moduleId={ModuleId}>
                                                        {isDraft && (
                                                            <div className="static-delete-container">
                                                                {category.rows.map((row, index) => (
                                                                    <div key={index} className="static-delete-btn">
                                                                        <button onClick={() => deleteRow(category.id, index)}>
                                                                            <img src={delete_icon} alt="Delete" className="delete_icon" />
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </AdditionalPermissionWrapper>

                                                </div>

                                                <AdditionalPermissionWrapper permissionKey="edit_inv_line" moduleId={ModuleId}>
                                                    {isDraft && (
                                                        <div
                                                            className="add_new_row"
                                                            onClick={() => addRow(category.id)}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <span className="add_new_row_popup">
                                                                <img src={plus_icon} alt="" />
                                                                Add Row
                                                            </span>
                                                        </div>
                                                    )}
                                                </AdditionalPermissionWrapper>

                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}

                    {/* approval flow */}

                    {(activeTab === 'approval') && (

                        <div style={{ backgroundColor: '#F9FAFB', minHeight: 'auto' }}>
                            <div style={{
                                backgroundColor: '#fff',
                                marginTop: '30px',
                                borderRadius: '8px',
                                width: '100%',
                                height: '100%',
                                position: 'relative',

                            }}>
                                {/* Close Button */}
                                {/* <button
                                    onClick={() => setShowTimeline(false)}
                                    style={{
                                        position: 'absolute',
                                        top: '20px',
                                        right: '20px',
                                        background: '#F9FAFB',
                                        border: '1px solid #E5E7EB',
                                        borderRadius: '50%',
                                        width: '32px',
                                        height: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '18px',
                                        color: '#1F2937',
                                        cursor: 'pointer',
                                    }}
                                >
                                    ×
                                </button> */}

                                {/* Title */}
                                <h2 style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    marginBottom: '24px',
                                    color: '#111827',
                                }}>
                                    History : {approvalHistory.length}
                                </h2>

                                {/* Timeline */}
                                <div style={{ position: 'relative', paddingLeft: '30px' }}>
                                    {/* Vertical Line */}
                                    <div style={{
                                        position: 'absolute',
                                        top: '24px',
                                        left: '14px',
                                        width: '1px',
                                        height: 'calc(100% - 24px)',
                                        backgroundImage: 'linear-gradient(#D1D5DB 33%, rgba(209, 213, 219, 0) 0%)',
                                        backgroundPosition: 'right',
                                        backgroundSize: '2px 10px',
                                        backgroundRepeat: 'repeat-y',
                                    }} />

                                    {approvalHistory.length === 0 ? (
                                        <div>
                                            No approval history available
                                        </div>
                                    ) : (
                                        approvalHistory.map((item, index) => (
                                            <div key={index} style={{ marginBottom: '40px', position: 'relative' }}>
                                                {/* Icon */}
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    backgroundColor: item.status.toLowerCase() === 'approved' ? '#C1F7D7' :
                                                        item.status.toLowerCase() === 'rejected' ? '#FECACA' : '#E5E7EB',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    position: 'absolute',
                                                    left: '-30px',
                                                    top: '12px',
                                                }}>
                                                    {item.status.toLowerCase() === 'approved' ? (
                                                        <img style={{ width: '20px' }} src={tick_icon} alt='Approved' />
                                                    ) : item.status.toLowerCase() === 'rejected' ? (
                                                        <span style={{ color: '#DC2626', fontWeight: 'bold', marginTop: '6px' }}>×</span>
                                                    ) : (
                                                        <span style={{ color: '#4B5563' }}>...</span>
                                                    )}
                                                </div>

                                                {/* Content */}
                                                <div style={{ marginLeft: '20px' }}>
                                                    <div style={{
                                                        fontWeight: '600',
                                                        fontSize: '15px',
                                                        color: '#19324C',
                                                        marginBottom: '4px',
                                                        textTransform: 'capitalize'
                                                    }}>
                                                        {item.status.toLowerCase() || 'Pending'}
                                                    </div>
                                                    <div style={{
                                                        fontSize: '14px',
                                                        color: '#19324C',
                                                        marginBottom: '2px',
                                                    }}>
                                                        {item.user_name || 'Unknown User'}
                                                    </div>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        color: '#9CA3AF'
                                                    }}>
                                                        {item.date_time || 'No date available'}
                                                    </div>
                                                    {item.comments && (
                                                        <div style={{
                                                            fontSize: '14px',
                                                            color: '#4B5563',
                                                            marginTop: '8px',
                                                            fontStyle: 'italic'
                                                        }}>
                                                            Comments: {item.comments}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default InvoiceEditModule;